import React from 'react';
import { ValidationErrors } from 'constants/validations';
import { Col, Form, FormModal, Row, Select, SupplierStatus } from 'components';
import { useChooseSupplierModal } from './useChooseSupplierModal';
import { useSupplierSelectListQuery } from 'api';
import { Typography } from 'antd';

const { Item } = Form;
const { Option } = Select;
const { Text } = Typography;

export interface IChooseSupplierModal {
  modalState: boolean;
  onModalStateChange: (value: boolean) => void;
  purchaseOrderItemIds: React.Key[];
}

export const ChooseSupplierModal: React.FC<IChooseSupplierModal> = (props) => {
  const { onModalStateChange, modalState, purchaseOrderItemIds } = props;
  const { onFinish, form, onCancel, isLoading } = useChooseSupplierModal({ onModalStateChange, purchaseOrderItemIds });
  const { data = [] } = useSupplierSelectListQuery();

  return (
    <FormModal
      form={form}
      title={'Choose Supplier'}
      okText={'Save'}
      open={modalState}
      isLoading={isLoading}
      onCancel={onCancel}
      onSubmit={onFinish}
      width={400}
    >
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Item
            label={'Supplier*'}
            name={'supplierId'}
            rules={[{ required: true, message: ValidationErrors.required('Supplier') }]}
          >
            <Select size={'large'}>
              {data.map((opt: Record<string, any>) => (
                <Option key={opt.id} value={opt.value} label={opt.label}>
                  <Row justify={'space-between'} wrap={false} className={'gap-4'}>
                    <Text ellipsis={{ tooltip: true }}>{opt.label}</Text>
                    <Col flex={'none'} style={{ textAlign: 'right' }}>
                      <SupplierStatus status={opt.status} />
                    </Col>
                  </Row>
                </Option>
              ))}
            </Select>
          </Item>
        </Col>
      </Row>
    </FormModal>
  );
};
